import { Injectable } from '@angular/core';
import {HttpClientService} from '../httpClient/httpclient.service';

@Injectable()
export class ProductsService {

  constructor (private h: HttpClientService) { }

  getMarketShareRevenue(searchData) {

    return this.h.post('/koncentro-analytics/products/market-share-revenue', searchData)
      .map(res => {
        return res;
      });
  }

  getConcentrationDiagramData(searchData) {
    return this.h.post('/koncentro-analytics/products/concentration-diagram', searchData)
      .map(res => {
        return res;
      });

  }

  getTriersRepeatersData(searchData) {
    return this.h.post('/koncentro-analytics/products/triers-repeaters', searchData)
      .map(res => {
        return res;
      });

  }

  getProductListData(searchData) {
   return this.h.post('/koncentro-analytics/products/product-list', searchData)
     .map(res => {
       return res;
     });
 }

  getCrossShoppingData(searchData) {
    return this.h.post('/koncentro-analytics/products/cross-shopping', searchData)
      .map(res => {
        return res;
      });
  }

  getCustomerOverviewData(searchData) {
    return this.h.post('/koncentro-analytics/products/customer-overview', searchData)
      .map(res => {
        return res;
      });

  }



}



// WEBPACK FOOTER //
// ./src/app/services/product/products.service.ts